"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var core_1 = require("@material-ui/core");
var CloseIcon_1 = __importDefault(require("../../../app/components/widgets/CloseIcon"));
var CreateLinkForm_1 = __importDefault(require("./CreateLinkForm"));
var fullScreenDialog_1 = __importDefault(require("../../helpers/fullScreenDialog"));
var ModalMargins_1 = __importDefault(require("./ModalMargins"));
var actions_1 = __importDefault(require("../../actions"));
var AddDescriptionForm_1 = __importDefault(require("./AddDescriptionForm"));
var ga_1 = require("../../../app/util/ga");
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return core_1.createStyles({
        headerDiv: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
        },
        headerText: {
            alignSelf: 'flex-end',
            marginTop: theme.spacing(6),
            marginBottom: theme.spacing(2),
        },
        closeIconButton: {
            fill: function (props) {
                return props.isFullScreenDialog ? '#BBBBBB' : theme.palette.primary.dark;
            },
            height: function (props) { return (props.isFullScreenDialog ? 44 : 30.8); },
            width: function (props) { return (props.isFullScreenDialog ? 44 : 30.8); },
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            marginLeft: function (props) { return (props.isFullScreenDialog ? 0 : theme.spacing(2)); },
            marginRight: function (props) { return (props.isFullScreenDialog ? 0 : theme.spacing(2)); },
        },
        headerWrapper: (_a = {
                background: theme.palette.background.default,
                boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.1)'
            },
            _a[theme.breakpoints.up('sm')] = {
                background: 'unset',
                boxShadow: 'unset',
            },
            _a),
    });
});
var CreateUrlModal = function () {
    var createUrlModal = react_redux_1.useSelector(function (state) { return state.user.createUrlModal; });
    var urlUploadState = react_redux_1.useSelector(function (state) { return state.user.uploadState.urlUpload; });
    var fileUploadState = react_redux_1.useSelector(function (state) { return state.user.uploadState.fileUpload; });
    var dispatch = react_redux_1.useDispatch();
    var closeCreateUrlModal = function () { return dispatch(actions_1.default.closeCreateUrlModal()); };
    var onCreateUrl = function (history) {
        return dispatch(actions_1.default.createUrlOrRedirect(history));
    };
    var onUploadFile = function (file) {
        return dispatch(actions_1.default.uploadFile(file));
    };
    var onBulkCreateUrl = function (file) {
        return dispatch(actions_1.default.bulkCreateUrl(file));
    };
    var isFullScreenDialog = fullScreenDialog_1.default();
    var classes = useStyles({ isFullScreenDialog: isFullScreenDialog });
    var _a = __read(react_1.useState(0), 2), step = _a[0], setStep = _a[1];
    react_1.useEffect(function () {
        if (fileUploadState) {
            closeCreateUrlModal();
            dispatch(actions_1.default.setFileUploadState(false));
        }
    }, [fileUploadState]);
    react_1.useEffect(function () {
        if (urlUploadState) {
            closeCreateUrlModal();
            dispatch(actions_1.default.setUrlUploadState(false));
        }
    }, [urlUploadState]);
    // Reset step when modal closes and reopens
    react_1.useEffect(function () {
        if (createUrlModal) {
            setStep(0);
            // Google Analytics: open link creation modal in user page
            ga_1.GAPageView('CREATE LINK PAGE');
            ga_1.GAEvent('user page', 'open link creation modal');
            return function () {
                // Google Analytics: close link creation modal in user page
                ga_1.GAPageView('USER PAGE');
            };
        }
        return undefined;
    }, [createUrlModal]);
    return (react_1.default.createElement(core_1.Dialog, { "aria-labelledby": "createUrlModal", "aria-describedby": "create-links", fullScreen: isFullScreenDialog, fullWidth: !isFullScreenDialog, maxWidth: "md", open: createUrlModal, onClose: closeCreateUrlModal },
        react_1.default.createElement("div", { className: classes.headerWrapper },
            react_1.default.createElement(ModalMargins_1.default, { applyRightMargin: false },
                react_1.default.createElement("div", { className: classes.headerDiv },
                    react_1.default.createElement(core_1.Typography, { className: classes.headerText, variant: isFullScreenDialog ? 'h6' : 'h3', color: "primary" }, step === 0
                        ? 'Create new link'
                        : "Done! You can now customise your link's visibility"),
                    react_1.default.createElement(core_1.IconButton, { className: classes.closeIconButton, onClick: closeCreateUrlModal, size: "small" },
                        react_1.default.createElement(CloseIcon_1.default, { size: isFullScreenDialog ? 36 : 24 }))))),
        step === 0 ? (react_1.default.createElement(CreateLinkForm_1.default, { onSubmitLink: onCreateUrl, onSubmitFile: onUploadFile, onSubmitBulk: onBulkCreateUrl })) : (react_1.default.createElement(AddDescriptionForm_1.default, null))));
};
exports.default = CreateUrlModal;
